import React, { useState } from "react";
import { Card, Button } from "react-bootstrap";
import ProjectModal from "../Common_profile_details_modals/ProjectModal/ProjectModal";

function ProjectsCard() {
  const [showModal, setShowModal] = useState(false);
  const [modalMode, setModalMode] = useState("add");

  const handleClose = () => {
    setShowModal(false);
  };

  const handleAdd = () => {
    setModalMode("add");
    setShowModal(true);
  };

  const handleEdit = () => {
    setModalMode("edit");
    setShowModal(true);
  };

  return (
    <>
      <Card className="profile-card-pattern profile-pattern-expandable">
        <Card.Body className="profile-card-pattern__body">
          {/* Header */}
          <div className="profile-card-pattern__header">
            <h2 className="profile-card-pattern__title">Projects</h2>

            <Button
              variant="link"
              className="profile-card-pattern__btn-add"
              aria-label="Add Project"
            >
              <span className="summary-card__edit-icon" onClick={handleAdd}>
                ➕
              </span>
            </Button>
          </div>

          {/* Project Item */}
          <div className="profile-pattern-block__item">
            <div className="profile-pattern-block__item-header">
              <h3 className="profile-pattern-block__main-text">
                Profcyma Career Solutions
              </h3>

              <Button
                variant="link"
                className="profile-card-pattern__btn-edit"
                aria-label="Edit Project"
              >
                <span className="summary-card__edit-icon" onClick={handleEdit}>
                  ✏️
                </span>
              </Button>
            </div>

            <p className="profile-pattern-block__sub-text">
              Profcyma Career Solutions is an EdTech career platform built for
              working professionals who want to grow without putting their
              careers on pause. We bridge the gap between ambition and
              opportunity by guiding learners toward the right online degrees
              and career pathways from India's top universities. With a focus on
              clarity, credibility, and career outcomes, Profcyma empowers
              professionals to upskill with confidence and make informed
              decisions that shape their future.
            </p>

            <a
              href="https://profcyma.com/"
              target="_blank"
              rel="noreferrer"
              className="profile-pattern-block__link"
            >
              https://profcyma.com/
            </a>
          </div>
        </Card.Body>
      </Card>

      <ProjectModal
        show={showModal}
        handleClose={handleClose}
        mode={modalMode}
      />
    </>
  );
}

export default ProjectsCard;
